import React from "react";

import OrderNumberCellContent from "../components/OrderNumberCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function orderNumber({ width, onResize }: Column.Options) {
	return base(
		ColumnId.OrderNumber,
		(item) => <OrderNumberCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default orderNumber;
